import { UseFormPayload } from '@domain-group/react-hooks'
import { Form, SectionDivider } from '@domain-group/suit-theme'

import { CampaignComparableModel } from '@domain-group/realhub-backend-api-types'

import Suburb from '../Suburb'

interface PropertyDetailsProps {
  campaignComparable: Partial<CampaignComparableModel>,
  campaignComparableFormPayload: UseFormPayload,
  geoCountryId?: number,
}

const PropertyDetails = (props: PropertyDetailsProps) => {
  const { campaignComparable, campaignComparableFormPayload, geoCountryId } = props

  const { id } = campaignComparable

  const {
    entityState: {
      post_code,
      state_name,
      street_name,
      street_number,
      unit_number,
    },
    errors,
    handlers,
  } = campaignComparableFormPayload

  return (
    <>
      <SectionDivider boxProps={!id ? { marginBottom: 'large' } : { marginY: 'large' }}>
        Property Details
      </SectionDivider>

      <Form.Row>
        <Form.Field label="Unit No">
          <input name="unit_number" type="text" value={unit_number} {...handlers} />
        </Form.Field>

        <Form.Field label="* Street No" errorMessage={errors.street_number}>
          <input name="street_number" type="text" value={street_number} {...handlers} />
        </Form.Field>
      </Form.Row>

      <Form.Field label="* Street Name" errorMessage={errors.street_name} marginTop="large">
        <input name="street_name" type="text" value={street_name} {...handlers} />
      </Form.Field>

      <Form.Field label="* Suburb Name" errorMessage={errors.suburb_name} marginTop="large">
        <Suburb campaignComparableForm={campaignComparableFormPayload} geo_country_id={geoCountryId} />
      </Form.Field>

      <Form.Row>
        <Form.Field label="* State" errorMessage={errors.state_name} marginTop="large">
          <input name="state_name" type="text" value={state_name} {...handlers} />
        </Form.Field>

        <Form.Field label="* Postcode" errorMessage={errors.post_code} marginTop="large">
          <input name="post_code" type="text" value={post_code} {...handlers} />
        </Form.Field>
      </Form.Row>
    </>
  )
}

export default PropertyDetails
